import { getDataConnector, getDataConnectorGlobal } from '../requests/request';
import { useAppSelector } from '../../../../../redux/hooks';
import { useState, useEffect } from 'react';
import IpsecconnectorVert from './graficosverticales/Ipsecconnectorvert';
import CloudconnectorVert from './graficosverticales/CloudConnectorver';
import Pruebachart from './graficosverticales/widgetconnectores';
import Cloudconnectoredge from './graficosverticales/ConnectorEdge';

type datos = {
    Available_DTR_VPN?: any,
    DateUpdate_DTR_VPN?: any,
    exceeded_DTR_VPN?: any,
    Total_DTR_VPN?: any,
    Available_DTR_CPR?: any,
    DateUpdate_DTR_CPR?: any,
    exceeded_DTR_CPR?: any,
    Total_DTR_CPR?: any,
    Subscription?: any,
    Available_DTR_EDG?: any,
    Total_DTR_EDG?: any,
    exceeded_DTR_EDG?: any,
    start?: any,
    end?: any,
    error?: any
};

export default function DataUsage(props: any) {
    const Id = useAppSelector(state => state.SuscriptionSlice.id);
    const Type = useAppSelector(state => state.CloudSlice.Type);
    const tenant = useAppSelector(state => state.TenantSlice.id);
    const nameregion = useAppSelector(state => state.RegionSlice.name);
    const FlagReg = useAppSelector(state => state.FlagSlice.value);

    const [DataAvailable, setDataAvailable] = useState<datos[]>([]);
    const [DataAvailableEdge, setDataAvailableEdge] = useState<any>();
    const [DataAvailableOne, setDataAvailableOne] = useState({
        start: '',
        end: '',
        DateUpdate_DTR_CPR: ''
    });

    useEffect(() => {
        const fetchData = async () => {
            try {
                let available;
                if (Id !== 0 && Type !== 'CloudGlobal') {
                    available = tenant === 0
                        ? await getDataConnector(Id, 'Home.DataUsage', Type, nameregion)
                        : await getDataConnectorGlobal(Id, tenant, 'Home.DataUsage', Type, nameregion);
                } else if (Id !== 0 && Type === 'CloudGlobal') {
                    available = tenant === 0
                        ? await getDataConnector(Id, 'Home.DataUsage')
                        : await getDataConnectorGlobal(Id, tenant, 'Home.DataUsage');
                }
                if (available?.data && available.data.error !== 'id suscription invalido') {
                    setDataAvailableOne(available.data);
                    setDataAvailableEdge(available.data);
                } else {
                    setDataAvailable([]);
                    setDataAvailableEdge([]);
                }
            } catch (error) {
                console.error('Error al obtener las cuentas:', error);
            }
        };
        fetchData();
    }, [Id, nameregion, props.id]);

    // useEffect(() => {
    //     const fetchData = async () => {
    //         console.log('id actual', Id, props.id)
    //         try {
    //             if (Id === -1) {
    //                 console.log('llega aqui')
    //                 const available = tenant === 0
    //                     ? await getDataConnector(-1, 'Home.DataUsage')
    //                     : await getDataConnectorGlobal(-1, tenant, 'Home.DataUsage');
    //                 if (available?.data && available.data.error !== 'id suscription invalido') {
    //                     setDataAvailable(available.data);
    //                     setDataAvailableEdge(available.data);
    //                 } else {
    //                     setDataAvailable([]);
    //                     setDataAvailableEdge([]);
    //                 }
    //             }
    //         } catch (error) {
    //             console.error('Error al obtener las cuentas:', error);
    //         }
    //     };
    //     fetchData();
    // }, [Id, nameregion, props.id]);

    let mesSiguiente;
    var date = new Date();
    var currentMonth = date.getMonth();
    var nextMonth = ++currentMonth;
    var nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
    mesSiguiente = nextMonthFirstDay.getDate() + "/" + (nextMonthFirstDay.getMonth() + 1) + "/" + nextMonthFirstDay.getFullYear();

    let CPR = DataAvailableEdge?.Available_DTR_CPR !== undefined;
    let EDG = DataAvailableEdge?.Available_DTR_EDG !== undefined;
    let IPSEC = DataAvailableEdge?.Available_DTR_VPN !== undefined;

    return (
        <div className='card-body d-flex flex-column'>
            {Id !== -1 && (
                <>
                    <div className="d-flex flex-column-auto flex-center">
                        <div className='text-center mb-5'>
                            <div className='f-titulo fs-gd text-marino'>CTX connectors</div>
                        </div>
                    </div>
                    <div className="d-flex flex-row flex-column-fluid">
                        <div style={{ marginLeft: '15px' }} className="d-flex flex-row-fluid flex-center col-5">
                            <label className='f-parrafo fs-p'>Last Update Date: {DataAvailableOne.DateUpdate_DTR_CPR}</label>
                        </div>
                    </div>
                    <br />
                    <div className="d-flex flex-column-auto flex-center">
                        <div className="alert alert-info d-flex align-items-center p-5 mb-0">
                            <div style={{ marginRight: '20px' }} className="d-flex flex-column">
                                <h5 className="mb-1 f-parrafo fs-p text-center">OUTBOUND DATA TRANSFER AVAILABLE FOR CTX</h5>
                                <h5 className="mb-1 f-parrafo fs-6 text-pink text-center">Periodo: {DataAvailableOne.start} al {DataAvailableOne.end}</h5>
                            </div>
                        </div>
                    </div>
                    <br />
                    <div className='row gx-xl-10'>
                        {IPSEC && <div className="col-xl-6">
                            <IpsecconnectorVert id={props.id} source='Home.DataUsage' />
                            <br />
                        </div>}
                        {CPR && <div className="col-xl-6">
                            <CloudconnectorVert id={props.id} source='Home.DataUsage' />
                        </div>}
                        {EDG && <div className="col-xl-6">
                            <Cloudconnectoredge id={props.id} source='Home.DataUsage' />
                        </div>}
                    </div>
                    <div className='row'>
                        <div className='col d-flex flex-center'>
                            {CPR && EDG && <div className="col-xl-6">
                                <Cloudconnectoredge id={props.id} source='Home.DataUsage' />
                            </div>}
                        </div>
                    </div>
                    <div className="d-flex flex-column text-center">
                        <h5 className='f-parrafo'>NEXT AVAILABLE DATA TRANSFER RENEWAL FOR ALL CONNECTORS: {mesSiguiente}</h5>
                    </div>
                    <div className="d-flex flex-column-auto flex-center">
                        <div className="alert alert-info d-flex align-items-center p-5 mb-0">
                            <span className="svg-icon svg-icon-2hx svg-icon-primary me-3">
                                <span className="w-24 h-30 svg-icon svg-icon-2hx svg-icon-primary me-4">
                                    <svg viewBox="0 0 24 24" width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" className="mh-50px">
                                        <path opacity="0.3" fill="black" d="M20.5543 4.37824L12.1798 2.02473C12.0626 1.99176 11.9376 1.99176 11.8203 2.02473L3.44572 4.37824C3.18118 4.45258 3 4.6807 3 4.93945V13.569C3 14.6914 3.48509 15.8404 4.4417 16.984C5.17231 17.8575 6.18314 18.7345 7.446 19.5909C9.56752 21.0295 11.6566 21.912 11.7445 21.9488C11.8258 21.9829 11.9129 22 12.0001 22C12.0872 22 12.1744 21.983 12.2557 21.9488C12.3435 21.912 14.4326 21.0295 16.5541 19.5909C17.8169 18.7345 18.8277 17.8575 19.5584 16.984C20.515 15.8404 21 14.6914 21 13.569V4.93945C21 4.6807 20.8189 4.45258 20.5543 4.37824Z"></path>
                                        <path d="M10.5606 11.3042L9.57283 10.3018C9.28174 10.0065 8.80522 10.0065 8.51412 10.3018C8.22897 10.5912 8.22897 11.0559 8.51412 11.3452L10.4182 13.2773C10.8099 13.6747 11.451 13.6747 11.8427 13.2773L15.4859 9.58051C15.771 9.29117 15.771 8.82648 15.4859 8.53714C15.1948 8.24176 14.7183 8.24176 14.4272 8.53714L11.7002 11.3042C11.3869 11.6221 10.874 11.6221 10.5606 11.3042Z" fill="black"></path>
                                    </svg>
                                </span>
                            </span>
                            <div className="d-flex flex-column">
                                <h5 className="mb-1 f-bold">Note</h5>
                                <span className='f-parrafo'>Inbound data towards CTX is unlimited. The charts refer only to OUTBOUND data.</span>
                            </div>
                        </div>
                    </div>
                </>
            )}
            {Id === -1 && Type === 'CloudGlobal' && DataAvailable?.map((dato: any) => (
                <>
                    <div className="d-flex flex-column-auto flex-center">
                        <div className='text-center mb-5'>
                            <div className='f-titulo fs-gd text-marino'>CTX connectors</div>
                        </div>
                    </div>
                    <div className="d-flex flex-column-auto flex-center">
                        <div className="alert alert-info d-flex align-items-center p-5 mb-0">
                            <div style={{ marginRight: '20px' }} className="d-flex flex-column">
                                <h5 className="mb-1 f-parrafo fs-p text-center">OUTBOUND DATA TRANSFER AVAILABLE FOR CTX</h5>
                                <h5 className="mb-1 f-parrafo fs-6 text-pink text-center">Periodo: {dato.start} al {dato.end}</h5>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex flex-column-auto flex-center">
                        <div className='text-center mb-5'>
                            <div className='text-gray-500 fw-semibold fs-6 mb-3'>Subscription:</div>
                            <h5 className='badge badge-light-success text-center fs-5'>{dato.Subscription}</h5>
                        </div>
                    </div>
                    <div className='row gx-xl-10'>
                        {dato.Available_DTR_VPN !== undefined && <div className="col-xl-6">
                            <Pruebachart
                                exedido={dato.exceeded_DTR_VPN}
                                name='IPSec connector'
                                total={dato.Total_DTR_VPN}
                                disponible={dato.Available_DTR_VPN}
                                className='card-xl-stretch mb-xl-8'
                                chartColor={dato.exceeded_DTR_VPN !== 0 ? 'danger' : 'marino'}
                                chartHeight={250}
                            />
                            <br />
                        </div>}
                        {dato.Available_DTR_CPR !== undefined && <div className="col-xl-6">
                            <Pruebachart
                                exedido={dato.exceeded_DTR_CPR}
                                name='Cloud Connector'
                                total={dato.Total_DTR_CPR}
                                disponible={dato.Available_DTR_CPR}
                                className='card-xl-stretch mb-xl-8'
                                chartColor={dato.exceeded_DTR_CPR !== 0 ? 'danger' : 'marino'}
                                chartHeight={250}
                            />
                        </div>}
                        {dato.Available_DTR_EDG !== undefined && <div className="col-xl-6">
                            <Pruebachart
                                exedido={dato.exceeded_DTR_EDG}
                                name='Edge Connector'
                                total={dato.Total_DTR_EDG}
                                disponible={dato.Available_DTR_EDG}
                                className='card-xl-stretch mb-xl-8'
                                chartColor={dato.exceeded_DTR_EDG !== 0 ? 'danger' : 'marino'}
                                chartHeight={250}
                            />
                        </div>}
                    </div>
                </>
            ))}
            {Id === -1 && Type === 'CloudGlobal' && (
                <div className="d-flex flex-column-auto flex-center">
                    <div className="alert alert-info d-flex align-items-center p-5 mb-0">
                        <span className="svg-icon svg-icon-2hx svg-icon-primary me-3">
                            <span className="w-24 h-30 svg-icon svg-icon-2hx svg-icon-primary me-4">
                                <svg viewBox="0 0 24 24" width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" className="mh-50px">
                                    <path opacity="0.3" fill="black" d="M20.5543 4.37824L12.1798 2.02473C12.0626 1.99176 11.9376 1.99176 11.8203 2.02473L3.44572 4.37824C3.18118 4.45258 3 4.6807 3 4.93945V13.569C3 14.6914 3.48509 15.8404 4.4417 16.984C5.17231 17.8575 6.18314 18.7345 7.446 19.5909C9.56752 21.0295 11.6566 21.912 11.7445 21.9488C11.8258 21.9829 11.9129 22 12.0001 22C12.0872 22 12.1744 21.983 12.2557 21.9488C12.3435 21.912 14.4326 21.0295 16.5541 19.5909C17.8169 18.7345 18.8277 17.8575 19.5584 16.984C20.515 15.8404 21 14.6914 21 13.569V4.93945C21 4.6807 20.8189 4.45258 20.5543 4.37824Z"></path>
                                    <path d="M10.5606 11.3042L9.57283 10.3018C9.28174 10.0065 8.80522 10.0065 8.51412 10.3018C8.22897 10.5912 8.22897 11.0559 8.51412 11.3452L10.4182 13.2773C10.8099 13.6747 11.451 13.6747 11.8427 13.2773L15.4859 9.58051C15.771 9.29117 15.771 8.82648 15.4859 8.53714C15.1948 8.24176 14.7183 8.24176 14.4272 8.53714L11.7002 11.3042C11.3869 11.6221 10.874 11.6221 10.5606 11.3042Z" fill="black"></path>
                                </svg>
                            </span>
                        </span>
                        <div className="d-flex flex-column">
                            <h5 className="mb-1">Note</h5>
                            <span className='f-parrafo'>Inbound data towards CTX is unlimited. the Charts refer only to OUTBOUND data.</span>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
